export default "__VITE_ASSET__BZfpYPC4__"